<section class="detail-section d-block" [attr.id]="id">
  <now-wbsuche-lib-responsive-collapse
    [maxHeight]="(maxHeight$ | async)!"
    [collapseButtonText]="collapseButtonText"
    (collapsedChange)="collapsedChanged.emit($event)"
  >
    <h2 class="h5 mt-0 mb-2">
      <i class="now-icon {{ icon }}" aria-hidden="true"></i>
      <div class="ms-2">{{ title }}</div>
    </h2>
    <ng-content></ng-content>
  </now-wbsuche-lib-responsive-collapse>
  <hr class="d-none d-print-block" />
</section>
